<template>
  <div class="container login-container">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'layout-default'
  }
</script>


// WEBPACK FOOTER //
// src/components/layout/layout-default.vue